.navButton {
  display: flex;
  color: #b3c0d0;
  align-items: center;
  padding: 0.5rem 0.85rem;
  border-radius: 8px;
  /* margin-bottom: 0.5rem; */
  transition: all 0.2s ease;
}

.sidebarWrapper {
  display: flex;
  gap: 0.2rem;
  align-items: center;
}

.navButton:hover {
  background-color: rgba(255, 255, 255, 0.08);
}

/* no blue browser focus glow on the active/clicked nav item */
.navButton:focus,
.navButton:focus-within,
.navButton:focus-visible,
.navButton a:focus,
.navButton a:focus-visible {
  outline: none;
  box-shadow: none;
}

.selectedbtn {
  background-color: rgba(255, 255, 255, 0.08);
}

/* small red dot indicator on the active nav link */
.selectedbtn::before {
  content: '';
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: var(--ib-red);
  box-shadow: 0 0 0 3px rgba(185, 28, 28, 0.25);
  margin-right: 0.5rem;
  flex: none;
}

.selectedbtn ion-icon {
  color: #ffffff;
}

.navText {
  padding-left: 0.3rem;
}

@media only screen and (max-width: 550px) {
  .layout {
    grid-template-columns: 1fr;
    grid-template-rows: 0.2fr auto 0.8fr;
    grid-template-areas:
      'nav'
      'main'
      'sidebarSmall';
  }
  .navText {
    padding: 0.3rem 0.3rem 0 0;
  }

  .selectedbtn {
    background-color: transparent;
  }

  /* red dot reads oddly stacked above the icon in the mobile column layout */
  .selectedbtn::before {
    display: none;
  }

  .selectedbtn ion-icon {
    color: var(--ib-red);
  }

  .navButton {
    padding: 0.5rem 1rem;
    justify-content: center;
    flex-direction: column;
  }

  .sidebarWrapper {
    display: flex;
    justify-content: space-evenly;
    width: 100%;
  }
}
